<template>
  <div style="text-align: center;">
    <p style="margin-top: 15px;">Would you like to create <strong>{{data.name}}__</strong>?</p>
    <button type="button" @click="create" class="btn btn-fill btn-info">
      Yes
    </button>
    <button type="button" @click="closeModal" class="btn btn-fill btn-info">
      No
    </button>
  </div>
</template>

<script>
  export default {
    props: ['data'],
    data() {
      return {
        addPlanName: false
      }
    },
    methods: {
      create () {
        this.addPlanName = true
        this.$store.commit('planNames/resetEdit')
        this.$eventHub.$emit('show-modal-4', 'Plan Name', this.data, '600px')
      },
      closeModal () {
        this.$emit('close')
      }
    },
    destroyed() {
      if (!this.addPlanName) {
        this.$eventHub.$emit('noPlanNameSelected')
      }
    }
  }
</script>
